import { FC, useEffect, useState } from 'react'
import MuiCircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'

const CircularProgress: FC<CircularProgressProps & { delay?: number }> = ({ delay, ...props }) => {
  const [shouldRender, setShouldRender] = useState(!delay)
  useEffect(() => {
    const timeout = delay
      ? setTimeout(() => {
          setShouldRender(true)
        }, delay)
      : undefined
    return () => {
      clearTimeout(timeout)
    }
  }, [delay])
  if (!shouldRender) {
    return null
  }
  return <MuiCircularProgress {...props} />
}

export default CircularProgress
